import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#ylry1q5lc__clip0_16836_221125)",
        children: [_jsx("path", {
          d: "M39 0H-6V30H39V0Z",
          fill: "white"
        }), _jsx("path", {
          d: "M39 10.9092H-6V19.091H39V10.9092Z",
          fill: "#003580"
        }), _jsx("path", {
          d: "M14 0H6.5V30H14V0Z",
          fill: "#003580"
        })]
      }), _jsx("rect", {
        x: "1",
        y: "1",
        width: "28",
        height: "28",
        rx: "14",
        stroke: "#152361",
        strokeWidth: "2"
      }), _jsx("defs", {
        children: _jsx("clipPath", {
          id: "ylry1q5lc__clip0_16836_221125",
          children: _jsx("rect", {
            width: "30",
            height: "30",
            rx: "15",
            fill: "white"
          })
        })
      })]
    }))
  });
};
export default Component;
